// src/api_scripts/get/getUsersList.js
import { fetchAllPages } from "../paginationUtils";

const getUsersList = async (unused, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/user`;

  try {
    // Use the pagination utility to fetch all pages
    const usersArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Users", 1000);

    // Transform users to combine firstName and lastName into name field for consistency
    const transformedUsers = usersArray.map(user => ({
      ...user,
      name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email || user.id
    }));

    console.log("Get Users List API Response Data (all pages):", transformedUsers.length, "items");
    return transformedUsers;

  } catch (error) {
    // If it's a 404, the API endpoint doesn't exist in this environment
    if (error.message && (error.message.includes('404') || error.message.includes('Request failed with status code 404'))) {
      console.warn(`Users API endpoint not available (404). This is expected in some environments.`);
      if (setProgress) {
        setProgress((prev) => [
          ...prev,
          { type: 'warning', message: 'Users API not available in this environment (404) - skipping', timestamp: new Date().toLocaleTimeString() }
        ]);
      }
      return []; // Return empty array instead of throwing error
    }

    console.error(`Error fetching Users:`, error);
    throw error; // Re-throw other errors
  }
};

export default getUsersList;